// extracted by mini-css-extract-plugin
export default {"title":"Partner_title__D6+ay","content":"Partner_content__EPTHN"};